var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.086,
    height: 94.098,
    viewBox: "0 0 91.086 94.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2772",
    "data-name": "Group 2772",
    transform: "translate(-2966.823 -6843.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2771",
    "data-name": "Group 2771",
    transform: "translate(-893 -1057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M3889.621,7958.65V7901h57.925v68.831",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M3897.52,7930.024a43.377,43.377,0,0,0,9.182,1.378c4.017,0,8.034-2.569,8.034-5.738s-5.624-5.165-8.034-5.739-8.034-2.569-8.034-5.738,4.017-5.739,8.034-5.739a63.671,63.671,0,0,1,9.181.917",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_800",
    "data-name": "Line 800",
    x2: 0.113,
    y2: 31.332,
    transform: "translate(3906.702 7904.774)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_801",
    "data-name": "Line 801",
    x2: 21.289,
    transform: "translate(3920.113 7907.057)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_802",
    "data-name": "Line 802",
    x2: 21.289,
    transform: "translate(3920.113 7915.482)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_803",
    "data-name": "Line 803",
    x2: 21.289,
    transform: "translate(3920.113 7923.907)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_804",
    "data-name": "Line 804",
    x2: 21.289,
    transform: "translate(3920.113 7932.332)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_805",
    "data-name": "Line 805",
    x2: 44.869,
    transform: "translate(3896.533 7943.182)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_806",
    "data-name": "Line 806",
    x2: 44.869,
    transform: "translate(3896.533 7951.607)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 12.937,
    height: 19.885,
    transform: "translate(3895.464 7961.65)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M3907.8,7964.5s6.4.133,9.456.133,8.031.994,11.014,2.983,0,7.954-4.971,5.965",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M3918.331,7971.593s8.949,3.977,12.926,3.977,8.745-3.052,11.351-4.474c4.557-2.486,6.91-1.39,7.539.5.994,2.983-2.982,5.965-4.971,6.96s-7.954,3.977-13.919,3.977-11.931-3.977-16.9-3.977-5.959,0-5.959,0",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.195
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(3859.823 7948.5)",
    fill: ""
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_798",
    "data-name": "Line 798",
    x2: 19.895,
    y2: 19.895,
    transform: "translate(3872.943 7962.052)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_799",
    "data-name": "Line 799",
    x1: 19.895,
    y2: 19.895,
    transform: "translate(3872.943 7962.052)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.ece55d0da2f18692b9a4ac0703b99918.svg";
export { ForwardRef as ReactComponent };